var map = {
	"./level1/01.mp3": 73,
	"./level1/02.mp3": 74,
	"./level1/03.mp3": 75,
	"./level1/04.mp3": 76,
	"./level1/05.mp3": 77,
	"./level1/06.mp3": 78,
	"./level2/01.mp3": 79,
	"./level2/02.mp3": 80,
	"./level2/03.mp3": 81,
	"./level2/04.mp3": 82,
	"./level2/05.mp3": 83,
	"./level2/06.mp3": 84,
	"./level3/01.mp3": 85,
	"./level3/02.mp3": 86,
	"./level3/03.mp3": 87,
	"./level3/04.mp3": 88,
	"./level3/05.mp3": 89,
	"./level3/06.mp3": 90,
	"./level4/01.mp3": 91,
	"./level4/02.mp3": 92,
	"./level4/03.mp3": 93,
	"./level4/04.mp3": 94,
	"./level4/05.mp3": 95,
	"./level4/06.mp3": 96,
	"./level5/01.mp3": 97,
	"./level5/02.mp3": 98,
	"./level5/03.mp3": 99,
	"./level5/04.mp3": 100,
	"./level5/05.mp3": 101,
	"./level5/06.mp3": 102,
	"./level6/01.mp3": 103,
	"./level6/02.mp3": 104,
	"./level6/03.mp3": 105,
	"./level6/04.mp3": 106,
	"./level6/05.mp3": 107,
	"./level6/06.mp3": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;